module.exports = __webpack_public_path__ + "videos/color-drop_en.a85cf34.mp4";